/**
 * Created by FlyingAnt on 3/23/16.
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Tick extends Component {
  static propTypes = {
    initializeCount: PropTypes.number,
    interval: PropTypes.number,
    addon: PropTypes.string,
    onComplete: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.interval = null
    this.tick = false
    this.state = {
      count: props.initializeCount
    }
  }

  registerInterval = () => {
    this.tick = true
    this.updateInterval()
  }

  unregisterInterval = () => {
    this.tick = false
    this.updateInterval()
  }

  componentDidMount () {
    this.registerInterval()
  }

  componentWillUnmount () {
    this.unregisterInterval()
  }

  updateInterval = () => {
    if (!this.tick && this.interval) {
      clearInterval(this.interval)
      this.interval = null
    } else if (this.tick && !this.interval) {
      this.interval = setInterval(this.updateContent, 1000 * this.props.interval)
    }
  }

  updateContent = () => {
    if (this.state.count === 0) {
      this.props.onComplete()
    } else {
      this.previous()
    }
  }

  next = () => {
    var count = this.state.count
    count++
    this.setState({
      count: count
    })
    this.updateInterval()
  }

  previous = () => {
    let count = this.state.count
    count--
    this.setState({
      count: count
    })
    this.updateInterval()
  }

  render () {
    return (
      <div>
        {this.state.count} {this.props.addon}
      </div>
    )
  }
}
